// extracted by mini-css-extract-plugin
export default {"wrapper":"AF-z","button":"BF-z","alternate":"CF-z","disabled":"DF-z","paymentWarning":"EF-z","fadeIn":"FF-z"};